import { setToast } from '@/entities/toast'
import { widgetWindowsSelector } from '@/entities/widgetWindows'
import { OperationsMapWidgetWindow } from '@/entities/widgetWindows/models/WidgetWindow'
import { updateWidgetWindow } from '@/entities/widgetWindows/widgetWindowsSlice'
import { TOOL_WIDGETS } from '@/shared/components/Mosaic/models/widgetType'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export const showUnassignedOnMap = createAsyncThunk<void, { scheduleId: EntityId }, ThunkApiContext>(
  'operations/showUnassignedOnMap',
  async ({ scheduleId }, { getState, dispatch }) => {
    const state = getState()
    const activeWidgetWindowId = state.widgetWindows.activeWidgetWindowId
    const mapWidgetWindows = widgetWindowsSelector.selectAll(state)
      .filter((widget) => widget.widgetType === TOOL_WIDGETS.Map)

    if (!activeWidgetWindowId) return

    let selectedMapWidgetWindow = mapWidgetWindows.find((widget) => widget.id === activeWidgetWindowId)

    if (!selectedMapWidgetWindow) {
      selectedMapWidgetWindow = mapWidgetWindows[0]
    }

    if (!selectedMapWidgetWindow) {
      dispatch(setToast({
        open: true,
        severity: 'error',
        title: 'No map widget presented in the layout',
        content: 'Drag and drop the map widget onto the layout before showing the shift on the map',
      }))

      return
    }

    const existingUnassignedScheduleIds = (selectedMapWidgetWindow as OperationsMapWidgetWindow).unassignedScheduleIds || []

    if (existingUnassignedScheduleIds.includes(scheduleId)) {
      return
    }

    // Add shift to map widget window
    dispatch(updateWidgetWindow({
      id: selectedMapWidgetWindow.id,
      changes: {
        unassignedScheduleIds: [...existingUnassignedScheduleIds, scheduleId],
      },
    }))
  })